import { formatDateRange } from '@spotify/confidence-core-react';

export const formatDateRangeFromStrings = (
  start?: string,
  end?: string,
): string => {
  if (!start && !end) return '';
  const s = new Date(start ?? end!);
  const e = new Date(end ?? start!);
  return formatDateRange(s, e);
};
